/**
 * @param forFeature {featureInterface}
 * @param toolSettings {array}
 * @returns {{postDiffData, featuresToUpdate}}
 */
export const getEditFeaturesRequestData = (forFeature, toolSettings) => {
  let postDiffData = null, featuresToUpdate = [];
  const toolSettingsDiff = getDifferentToolSettings(toolSettings, forFeature.dbFeature.updatedToolSettings || forFeature.dbFeature.toolSettings)
  if (!toolSettingsDiff.length) {
    return {postDiffData, featuresToUpdate} // we didn't change anything, no need to post
  }
  featuresToUpdate = getSameNameFeatures(forFeature);
  postDiffData = {
    "edit": toolSettingsDiff.map(toolSetting => {
      return {
        "FabricatorFeatureIds": featuresToUpdate.map(f => f.dbFeature.id),
        "EnableVisualizer": toolSetting["enableVisualizer"],
        "EnableQuotingTool": toolSetting["enableQuotingTool"],
        "Tool": toolSetting.tool,
      }
    })
  }
  return {postDiffData, featuresToUpdate}
}

/**
 * @param forFeature {featureInterface}
 * @returns featureInterface[]
 */
const getSameNameFeatures = (forFeature) => {
  const featureGroup = forFeature.getParent();
  let features = [forFeature];
  const nameToCompare = forFeature.getMatchingFeatureName();
  Object.keys(featureGroup.featuresList).forEach(layoutType => {
    [...featureGroup.featuresList[layoutType], ...featureGroup.featuresPartsList[layoutType]].forEach(feature => {
      if (nameToCompare === feature.getMatchingFeatureName() && !features.some(f => {
        return f.dbFeature.id === feature.dbFeature.id
      })) {
        features.push(feature);
      }
    })
  });
  return features
}

/**
 * @param newToolSettings {array}
 * @param oldToolSettings {array}
 * @returns array
 */
export const getDifferentToolSettings = (newToolSettings, oldToolSettings) => {
  return newToolSettings.filter(toolSetting => {
    const existingObject = oldToolSettings.find(set => set.tool === toolSetting.tool)
    if (!existingObject) {
      return true
    }
    return (existingObject["enableVisualizer"] !== toolSetting["enableVisualizer"])
      || (existingObject["enableQuotingTool"] !== toolSetting["enableQuotingTool"])
  })
}
